(() => {
  const WEBHOOK_URL = 'https://n8n.edenart.com/webhook/shopify-lead';
  const RECAPTCHA_SITE_KEY = '6Lf_4mEpAAAAAER0FqY5vY3Bi_q7NdKxzNM_mKz6';
  const PHONE_CSS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/css/intlTelInput.css';
  const PHONE_SCRIPT_URL = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/intlTelInput.min.js';
  const PHONE_UTILS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.js';

  const countryCodes = {
    fr: '+33 (France)', us: '+1 (United States)', ca: '+1 (Canada)', gb: '+44 (United Kingdom)',
    il: '+972 (Israel)', be: '+32 (Belgium)', ch: '+41 (Switzerland)', lu: '+352 (Luxembourg)',
    mc: '+377 (Monaco)', it: '+39 (Italy)', es: '+34 (Spain)', pt: '+351 (Portugal)',
    de: '+49 (Germany)', nl: '+31 (Netherlands)', at: '+43 (Austria)', dk: '+45 (Denmark)',
    se: '+46 (Sweden)', no: '+47 (Norway)', ie: '+353 (Ireland)', gr: '+30 (Greece)',
    ae: '+971 (United Arab Emirates)', sa: '+966 (Saudi Arabia)', qa: '+974 (Qatar)',
    kw: '+965 (Kuwait)', hk: '+852 (Hong Kong)', sg: '+65 (Singapore)', cn: '+86 (China)',
    jp: '+81 (Japan)', kr: '+82 (South Korea)', au: '+61 (Australia)', ru: '+7 (Russia)',
    tr: '+90 (Turkey)', in: '+91 (India)', br: '+55 (Brazil)', mx: '+52 (Mexico)',
    za: '+27 (South Africa)'
  };

  function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
  }

  function value(form, name) {
    const field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function setStatus(status, message, type) {
    if (!status) return;
    status.textContent = message;
    status.classList.remove('is-error', 'is-success');
    if (type) status.classList.add(`is-${type}`);
  }

  function loadRecaptcha() {
    if (window.grecaptcha?.ready && window.grecaptcha?.execute) return Promise.resolve();
    if (window.rkRecaptchaLoading) return window.rkRecaptchaLoading;

    window.rkRecaptchaLoading = new Promise((resolve, reject) => {
      let script = document.querySelector('script[data-rk-recaptcha]');
      if (!script) {
        script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(RECAPTCHA_SITE_KEY)}`;
        script.async = true;
        script.defer = true;
        script.dataset.rkRecaptcha = 'true';
        document.head.appendChild(script);
      }

      const startedAt = Date.now();
      const timer = window.setInterval(() => {
        if (window.grecaptcha?.ready && window.grecaptcha?.execute) {
          window.clearInterval(timer);
          resolve();
        } else if (Date.now() - startedAt >= 10000) {
          window.clearInterval(timer);
          reject(new Error('reCAPTCHA failed to load.'));
        }
      }, 100);
    });

    return window.rkRecaptchaLoading;
  }

  function getRecaptchaToken(action) {
    if (window.edenRecaptcha?.getToken) {
      return window.edenRecaptcha.getToken(action).then((result) => {
        const token = result && typeof result === 'object' ? result.token : result;
        if (!token) throw new Error('reCAPTCHA returned an empty token.');
        return token;
      });
    }

    return loadRecaptcha().then(() => new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => reject(new Error('reCAPTCHA timed out.')), 10000);
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action })
          .then((token) => {
            window.clearTimeout(timeout);
            if (!token) reject(new Error('reCAPTCHA returned an empty token.'));
            else resolve(token);
          })
          .catch((error) => {
            window.clearTimeout(timeout);
            reject(error);
          });
      });
    }));
  }

  function loadPhoneLibrary() {
    if (window.intlTelInput) return Promise.resolve();
    if (window.rkPhoneLoading) return window.rkPhoneLoading;

    if (!document.querySelector('link[data-rk-phone-css]')) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = PHONE_CSS_URL;
      stylesheet.dataset.rkPhoneCss = 'true';
      document.head.appendChild(stylesheet);
    }

    window.rkPhoneLoading = new Promise((resolve, reject) => {
      let script = document.querySelector('script[data-rk-phone-script]');
      if (!script) {
        script = document.createElement('script');
        script.src = PHONE_SCRIPT_URL;
        script.async = true;
        script.dataset.rkPhoneScript = 'true';
        document.head.appendChild(script);
      }
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error('Phone input failed to load.')), { once: true });
    });

    return window.rkPhoneLoading;
  }

  function initializePhone(form) {
    const input = form.querySelector('[data-rk-phone]');
    if (!input) return Promise.resolve(null);

    const dropdownContainer = form.dataset.rkPhoneDropdownContainer === 'event-dialog'
      ? form.closest('[data-event-rsvp-dialog]')
      : null;

    return loadPhoneLibrary()
      .then(() => {
        const options = {
          initialCountry: (form.dataset.defaultCountry || 'us').toLowerCase(),
          separateDialCode: true,
          utilsScript: PHONE_UTILS_URL
        };
        if (dropdownContainer) options.dropdownContainer = dropdownContainer;

        const instance = window.intlTelInput(input, options);
        if (dropdownContainer) {
          const scrollPanel = form.closest('.event-rsvp__panel');
          const positionCountryList = () => {
            const list = dropdownContainer.querySelector('.iti__country-list');
            const panel = form.closest('.event-rsvp__panel');
            if (!list || !panel || list.classList.contains('iti__hide')) return;

            const inputRect = input.getBoundingClientRect();
            const panelRect = panel.getBoundingClientRect();
            const width = Math.max(0, Math.min(panelRect.width - 40, window.innerWidth - 24));
            const left = Math.max(12, Math.min(inputRect.left, window.innerWidth - width - 12));
            const maxHeight = Math.min(340, window.innerHeight * 0.45);
            const roomBelow = window.innerHeight - inputRect.bottom - 12;
            const openAbove = roomBelow < Math.min(190, maxHeight) && inputRect.top > maxHeight + 12;
            const top = openAbove
              ? Math.max(12, inputRect.top - maxHeight)
              : Math.min(inputRect.bottom, window.innerHeight - maxHeight - 12);

            list.style.setProperty('position', 'fixed', 'important');
            list.style.setProperty('left', `${left}px`, 'important');
            list.style.setProperty('right', 'auto', 'important');
            list.style.setProperty('top', `${top}px`, 'important');
            list.style.setProperty('width', `${width}px`, 'important');
            list.style.setProperty('max-width', `${width}px`, 'important');
            list.style.setProperty('max-height', `${maxHeight}px`, 'important');
            list.style.setProperty('z-index', '2147483647', 'important');
          };

          input.addEventListener('open:countrydropdown', () => window.requestAnimationFrame(positionCountryList));
          window.addEventListener('resize', positionCountryList, { passive: true });
          scrollPanel?.addEventListener('scroll', () => {
            window.dispatchEvent(new Event('scroll'));
          }, { passive: true });
        }
        if (instance.promise) return instance.promise.then(() => instance);
        return instance;
      })
      .catch((error) => {
        console.warn('International phone input unavailable:', error);
        return null;
      });
  }

  function phoneDetails(instance) {
    if (!instance) return { countryCode: '', countryPhone: '' };
    const country = instance.getSelectedCountryData();
    if (!country?.dialCode) return { countryCode: '', countryPhone: '' };
    const countryName = (country.name || '').split(' (')[0].trim();
    return {
      countryCode: countryCodes[country.iso2] || `+${country.dialCode} (${countryName})`,
      countryPhone: countryName
    };
  }

  function setConsentDefault(form) {
    const consent = form.elements.namedItem('newsletter');
    if (!consent || form.dataset.rkConsentAuto !== 'true') return;
    let isEurope = false;
    try {
      isEurope = /^Europe\//.test(Intl.DateTimeFormat().resolvedOptions().timeZone || '');
    } catch (_error) {
      isEurope = false;
    }
    consent.checked = !isEurope;
  }

  function initializeForm(form) {
    if (form.dataset.rkInitialized === 'true') return;
    form.dataset.rkInitialized = 'true';

    const status = form.querySelector('[data-rk-form-status]');
    const submit = form.querySelector('[type="submit"]');
    const phoneInput = form.querySelector('[data-rk-phone]');
    const phonePromise = initializePhone(form);
    setConsentDefault(form);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (value(form, 'company_website')) {
        setStatus(status, form.dataset.successMessage || 'Thank you.', 'success');
        form.reset();
        return;
      }

      if (!form.checkValidity()) {
        setStatus(status, 'Please complete all required fields.', 'error');
        form.reportValidity();
        return;
      }

      const email = value(form, 'email');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setStatus(status, 'Please enter a valid email address.', 'error');
        form.elements.namedItem('email')?.focus();
        return;
      }

      const phone = await phonePromise;
      if (phoneInput && !phoneInput.value.trim()) {
        setStatus(status, 'Please enter your phone number.', 'error');
        phoneInput.focus();
        return;
      }
      if (phone && phone.isValidNumber && !phone.isValidNumber()) {
        setStatus(status, 'Please enter a valid phone number.', 'error');
        phoneInput.focus();
        return;
      }

      const details = phoneDetails(phone);
      const tracking = window.edenTracking?.capture ? window.edenTracking.capture() : {};
      const mobile = isMobile();
      const kind = form.dataset.rkFormKind || 'lead';
      const consent = form.elements.namedItem('newsletter');
      const action = form.dataset.recaptchaAction || (kind === 'newsletter' ? 'newsletter' : 'lead');
      const payload = {
        form_name: mobile
          ? (form.dataset.rkFormNameMobile || form.dataset.rkFormName)
          : form.dataset.rkFormName,
        first_name: value(form, 'first_name'),
        last_name: value(form, 'last_name'),
        email,
        country_code: details.countryCode,
        country_phone: details.countryPhone,
        phone: value(form, 'phone'),
        subject: value(form, 'subject'),
        message: value(form, 'message'),
        newsletter: kind === 'newsletter' ? true : Boolean(consent?.checked),
        utm_source: tracking.utm_source || '',
        utm_medium: tracking.utm_medium || '',
        utm_campaign: tracking.utm_campaign || '',
        utm_content: tracking.utm_content || '',
        utm_term: tracking.utm_term || '',
        gclid: tracking.gclid || '',
        fbclid: tracking.fbclid || '',
        referrer: tracking.referrer || '',
        form_url: window.location.href,
        device: mobile ? 'Mobile' : 'Desktop'
      };

      if (form.elements.namedItem('budget')) payload.budget = value(form, 'budget');
      if (form.elements.namedItem('sku')) payload.sku = value(form, 'sku');
      if (form.elements.namedItem('product')) payload.product = value(form, 'product');
      if (form.elements.namedItem('product_url')) payload.product_url = value(form, 'product_url');
      if (form.elements.namedItem('event')) payload.event = value(form, 'event');
      if (form.elements.namedItem('event_url')) payload.event_url = value(form, 'event_url');
      const guestsField = form.elements.namedItem('guests') || form.elements.namedItem('number_of_guests');
      if (guestsField) payload.guests = guestsField.value;
      if (form.elements.namedItem('number_of_guests')) payload.number_of_guests = value(form, 'number_of_guests');
      if (form.elements.namedItem('rsvp_hidden_field')) payload.rsvp_hidden_field = value(form, 'rsvp_hidden_field');
      if (form.elements.namedItem('campaign_id')) payload.campaign_id = value(form, 'campaign_id');

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      setStatus(status, kind === 'newsletter' ? 'Signing up…' : 'Sending…', '');

      try {
        const token = await getRecaptchaToken(action);
        payload.recaptcha_token = token;
        payload['g-recaptcha-response'] = token;
        payload.recaptcha_action = action;

        const response = await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        window.edenTracking?.clear?.();
        if (form.dataset.successUrl) {
          window.location.href = form.dataset.successUrl;
          return;
        }
        form.reset();
        setConsentDefault(form);
        if (phone) {
          phone.setNumber('');
          phone.setCountry((form.dataset.defaultCountry || 'us').toLowerCase());
        }
        setStatus(status, form.dataset.successMessage || 'Thank you. Your message has been sent.', 'success');
        form.dispatchEvent(new CustomEvent('rk:form:success', { bubbles: true }));
      } catch (error) {
        console.error('Form submission failed:', error);
        setStatus(status, 'Something went wrong. Please try again.', 'error');
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  }

  function initializeForms(root = document) {
    if (root.matches?.('[data-rk-lead-form]')) initializeForm(root);
    root.querySelectorAll?.('[data-rk-lead-form]').forEach(initializeForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeForms());
  } else {
    initializeForms();
  }

  document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));
})();
